"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _core = require("@emotion/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ICON_PLACEHOLDER_PATH_SHARP = (0, _core.jsx)(React.Fragment, null, (0, _core.jsx)("path", {
  d: "M3 3H6V4H4V6H3V3Z"
}), (0, _core.jsx)("path", {
  d: "M18 3H21V6H20V4H18V3Z"
}), (0, _core.jsx)("path", {
  d: "M4 18V20H6V21H3V18H4Z"
}), (0, _core.jsx)("path", {
  d: "M21 18V21H18V20H20V18H21Z"
}), (0, _core.jsx)("path", {
  d: "M10 4H7V3H10V4Z"
}), (0, _core.jsx)("path", {
  d: "M13 4H11V3H13V4Z"
}), (0, _core.jsx)("path", {
  d: "M17 4V3H14V4H17Z"
}), (0, _core.jsx)("path", {
  d: "M17 21V20H14V21H17Z"
}), (0, _core.jsx)("path", {
  d: "M13 21V20H11V21H13Z"
}), (0, _core.jsx)("path", {
  d: "M10 21V20H7V21H10Z"
}), (0, _core.jsx)("path", {
  d: "M4 7H3V10H4V7Z"
}), (0, _core.jsx)("path", {
  d: "M21 7V10H20V7H21Z"
}), (0, _core.jsx)("path", {
  d: "M4 11H3V13H4V11Z"
}), (0, _core.jsx)("path", {
  d: "M21 11V13H20V11H21Z"
}), (0, _core.jsx)("path", {
  d: "M4 14H3V17H4V14Z"
}), (0, _core.jsx)("path", {
  d: "M21 14V17H20V14H21Z"
}), (0, _core.jsx)("path", {
  d: "M19 5H18.9596L19 5.04044V5Z"
}), (0, _core.jsx)("path", {
  d: "M5 5V5.04052L5.04052 5H5Z"
}), (0, _core.jsx)("path", {
  d: "M5 19H5.04044L5 18.9596V19Z"
}), (0, _core.jsx)("path", {
  d: "M19 19V18.9596L18.9596 19H19Z"
}), (0, _core.jsx)("path", {
  d: "M18 5.29293L18.7071 6.00004L16.6667 8.04048L15.9596 7.33337L18 5.29293Z"
}), (0, _core.jsx)("path", {
  d: "M15.3334 7.9596L16.0405 8.6667L14 10.7071L13.2929 10L15.3334 7.9596Z"
}), (0, _core.jsx)("path", {
  d: "M12.6667 10.6263L13.3738 11.3334L12.7071 12L13.3738 12.6667L12.6667 13.3738L12 12.7071L11.3334 13.3738L10.6263 12.6667L11.2929 12L10.6263 11.3334L11.3334 10.6263L12 11.2929L12.6667 10.6263Z"
}), (0, _core.jsx)("path", {
  d: "M10 13.2929L10.7071 14L8.66671 16.0405L7.9596 15.3334L10 13.2929Z"
}), (0, _core.jsx)("path", {
  d: "M7.33337 15.9596L8.04048 16.6667L6.00004 18.7071L5.29293 18L7.33337 15.9596Z"
}), (0, _core.jsx)("path", {
  d: "M6.00004 5.29293L5.29293 6.00004L7.33337 8.04048L8.04048 7.33337L6.00004 5.29293Z"
}), (0, _core.jsx)("path", {
  d: "M8.6667 7.9596L7.9596 8.6667L10 10.7071L10.7071 10L8.6667 7.9596Z"
}), (0, _core.jsx)("path", {
  d: "M14 13.2929L13.2929 14L15.3334 16.0405L16.0405 15.3334L14 13.2929Z"
}), (0, _core.jsx)("path", {
  d: "M16.6667 15.9596L15.9596 16.6667L18 18.7071L18.7071 18L16.6667 15.9596Z"
}));
var _default = exports.default = ICON_PLACEHOLDER_PATH_SHARP;